import { Close } from '@mui/icons-material';
import { Box, Divider, IconButton, Typography } from '@mui/material';

type IntakeDrawerTitleProps = {
  title: string;
  handleCloseDrawer: () => void;
};

export const IntakeDrawerTitle = ({ title, handleCloseDrawer }: IntakeDrawerTitleProps) => {
  return (
    <>
      <Box
        sx={{
          p: 2,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 12px 12px 24px',
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={handleCloseDrawer}>
          <Close />
        </IconButton>
      </Box>
      <Divider />
    </>
  );
};
